export const FIELD_LABELS = Object.freeze({
  username: 'ID',
  password: '비밀번호',
  password2: '비밀번호확인',
  new_password: '새 비밀번호',
  new_password2: '새 비밀번호 다시 입력',
  email: '이메일',
  name: '이름',
  nickname: '닉네임',
  clinic_name: '병원명',
  clinic_address: '병원주소',
  mobile: '전화번호',
  representative: '초대 과대 이름',
  president: '총대 이름',
  dummy: '실습실 더미 애칭',
});

export const ERROR_MESSAGES = Object.freeze({
  // Generic
  BLANK: (field) => `${FIELD_LABELS[field]} 입력은 필수입니다.`,
  REQUIRED: (field) => `${FIELD_LABELS[field]} 입력은 필수입니다.`,
  INVALID: (field) => `잘못된 형식의 ${FIELD_LABELS[field]} 입니다.`,
  INVALID_FORMAT: (field) => `잘못된 형식의 ${FIELD_LABELS[field]} 입니다.`,
  INVALID_VALUE: (field) => `올바르지 않은 ${FIELD_LABELS[field]} 입니다.`,
  ALREADY_EXISTS: (field)  => `이미 존재하는 ${FIELD_LABELS[field]} 입니다. 사용할 수 없습니다.`,
  MIN_LENGTH: (field) => `${FIELD_LABELS[field]} 길이가 너무 짧습니다.`,
  MAX_LENGTH: (field) => `${FIELD_LABELS[field]} 길이가 너무 깁니다.`,
  MAX_VALUE: (field) => `${FIELD_LABELS[field]} 값이 너무 큽니다.`,
  MIN_VALUE: (field) => `${FIELD_LABELS[field]} 값이 너무 작습니다.`,
  
  // Specific
  NULL_NOT_ALLOWED: () => 'null 값은 허용되지 않습니다.', 
  
  INCORRECT_REPRESENTATIVE: () => '틀렸습니다.',
  INCORRECT_PRESIDENT: () => '틀렸습니다.',
  INCORRECT_DUMMY: () => '틀렸습니다.',
  REGISTER_TOKEN_EXPIRED: () => '회원가입 검증 토큰이 만료되었습니다. 처음부터 다시 시도해 주세요',
  INVALID_REGISTER_TOKEN: () => '회원가입 검증 토큰이 올바르지 않습니다. 처음부터 다시 시도해 주세요',
  REGISTER_RACE_CONDITION: () => '요청이 이미 처리되었거나 만료되었습니다. 로그인을 시도해 보세요.',
  OAUTH_STATE_MISSING: () => '인증이 만료되었거나 올바르지 않습니다. 다시 시도해 주세요.',
  OAUTH_PENDING_TOKEN_MISSING: () => '인증 데이터가 만료되었거나 올바르지 않습니다. 처음부터 다시 시도해 주세요',
  OAUTH_PENDING_DATA_MISSING: () => '인증 데이터가 만료되었거나 올바르지 않습니다. 처음부터 다시 시도해주세요',
  OAUTH_COMPLETE_ALREADY_EXISTS: () => '이미 존재하는 값입니다. 처음부터 다시 시도해 주세요.',
  OAUTH_COMPLETE_INTEGRITY_ERROR: () => '이미 존재하는 값입니다. 처음부터 다시 시도해 주세요',
  OAUTH_COMPLETE_RACE_CONDITION: () => '요청이 이미 처리되었거나 만료되었습니다. 로그인을 시도해 보세요.',
  
  INVITE_TOKEN_INVALID: () => '인증 데이터가 만료되었거나 올바르지 않습니다.',
  INVITE_TOKEN_MISSING: () => '인증 데이터가 만료되었거나 올바르지 않습니다.',
  INVITE_PENDING_DATA_MISSING: () => '인증 데이터가 만료되었거나 올바르지 않습니다.',
  INVITE_COMPLETE_FAILED: () => '인증 데이터가 올바르지 않거나 만료되었습니다.',
  INVITE_COMPLETE_RACE_CONDITION: () => '요청이 이미 처리되었거나 만료되었습니다. 로그인을 시도해 보세요.',
  
  PASSWORD_INCORRECT: () => '현재 비밀번호가 틀렸습니다.',
  PASSWORD_MISMATCH: () => '비밀번호가 일치하지 않습니다.',
  PASSWORD_TOO_SHORT: () => '비밀번호가 너무 짧습니다.',
  PASSWORD_TOO_LONG: () => '비밀번호가 너무 깁니다.',
  PASSWORD_ALPHA_REQUIRED: () => '비밀번호에 영문자가 포함되어야 합니다.',
  PASSWORD_DIGIT_REQUIRED: () => '비밀번호에 숫자가 포함되어야 합니다.',
  PASSWORD_SPECIAL_REQUIRED: () => '비밀번호에 특수문자가 포함되어야 합니다.',
  PASSWORD_RESET_TOKEN_INVALID: () => '인증 데이터가 만료되었거나 올바르지 않습니다.',
  PASSWORD_RESET_USER_NOT_FOUND: () => '사용자 계정이 일지하지 않습니다. 확인 후 다시 시도해 주세요',
  PASSWORD_RESET_RACE_CONDITION: () => '요청이 이미 처리되었거나 만료되었습니다. 로그인을 시도해 보세요.',
    
  INVALID_EMAIL: () => '이메일 주소가 올바르지 않습니다. 확인해 주세요.',
  INVALID_MOBILE: () => '전화번호가 올바르지 않습니다. 확인해 주세요.',
  VERIFY_EMAIL_COOLDOWN: () => '인증번호를 다시 요청할수 있는 시간이 아닙니다. 잠시 후 다시 시도해 주세요.',
  VERIFY_MOBILE_COOLDOWN: () => '인증번호를 다시 요청할수 있는 시간이 아닙니다. 잠시 후 다시 시도해 주세요.',
  VERIFY_EMAIL_ATTEMPT_LIMIT: () => '시도 가능 횟수를 초과하였습니다. 처음부터 다시 시도해 주세요.',
  VERIFY_MOBILE_ATTEMPT_LIMIT: () => '시도 가능 횟수를 초과하였습니다. 처음부터 다시 시도해 주세요.',
  VERIFY_EMAIL_DAILY_LIMIT: () => '하루 발송 허용량을 초과하였습니다. 24시간 뒤에 다시 시도해 주세요.',
  VERIFY_MOBILE_DAILY_LIMIT: () => '하루 발송 허용량을 초과하였습니다. 24시간 뒤에 다시 시도해 주세요.',
  VERIFY_EMAIL_IP_LIMIT: () => '요청 가능 횟수를 초과했습니다. 24시간 뒤에 다시 다시 시도해 주세요.',
  VERIFY_MOBILE_IP_LIMIT: () => '요청 가능 횟수를 초과했습니다. 24시간 뒤에 다시 다시 시도해 주세요.',
  VERIFY_EMAIL_CODE_EXPIRED: () => '인증 코드가 만료되었습니다. 처음부터 다시 시도해 주세요.',
  VERIFY_MOBILE_CODE_EXPIRED: () => '인증 코드가 만료되었습니다. 처음부터 다시 시도해 주세요.',
  VERIFY_EMAIL_CODE_MISMATCH: () => '인증 코드가 올바르지 않습니다. 다시 시도해 주세요.',
  VERIFY_MOBILE_CODE_MISMATCH: () => '인증 코드가 올바르지 않습니다. 다시 시도해 주세요.',
  INVALID_CREDENTIALS: () => '로그인에 실패했습니다. 확인후 다시 시도해 주세요',
  INTEGRITY_ERROR_ALREADY_EXISTS: () => '이미 존재하는 값입니다. 다시 시도해 주세요.',
  ACCOUNT_NOT_FOUND: () => '일치하는 계정을 찾을 수 없습니다.',
    
  EMAIL_VERIFICATION_CODE_SEND_FAILED: () => '인증코드 발송에 실패하였습니다. 다시 시도해 주세요.',
  EMAIL_INVITE_SEND_FAILED: () => '초청에 실패하였습니다. 다시 시도해 주세요.',
  SMS_VERIFICATION_CODE_SEND_FAILED: () => '인증코드 발송에 실패하였습니다. 다시 시도해 주세요.',
  KAKAO_VERIFICATION_CODE_SEND_FAILED: () => '인증코드 발송에 실패하였습니다. 다시 시도해 주세요.',
  
  REFRESH_TOKEN_MISSING: () => '인증되지 않았습니다. 다시 로그인 해주세요.',
  REFRESH_TOKEN_INVALID: () => '인증되지 않았습니다. 다시 로그인 해주세요.',
  REFRESH_TOKEN_USER_ID_MISSING: () => '인증되지 않았습니다. 다시 로그인 해주세요.',
  REFRESH_TOKEN_USER_MISSING: () => '인증되지 않았습니다. 다시 로그인 해주세요.',
  REFRESH_TOKEN_USER_INVACTIVE: () => '인증되지 않았습니다. 다시 로그인 해주세요.',
  REFRESH_TOKEN_BLACKLIST_FAILED: () => '인증 과정에 문제가 발생하였습니다. 다시 로그인 해주세요.',

  CSRF_TOKEN_MISSING: () => 'CSRF 토큰이 존재하지 않습니다. 다시 시도해 주세요',
  CSRF_TOKEN_INVALID: () => 'CSRF 토큰이 유효하지 않습니다. 다시 시도해 주세요',

  THROTTLED: () => '오류 횟수 초과 입니다.',

  OAUTH_CONFIG_FAILED: () => '인증서버 문제가 있습니다. 잠시 후 다시 시도해 주세요',
  OAUTH_AUTHENTICATE_FAILED: () => '인증서버 오류입니다. 잠시 후 다시 시도해 주세요',
  OAUTH_GET_TOKEN_FAILED: () => '인증서버 오류입니다. 다시 시도해 주세요',
  OAUTH_GET_TOKEN_ERROR: () => '인증서버 오류입니다. 다시 시도해 주세요',
  OAUTH_REFRESH_SERVER_ERROR: () => '인증서버 오류입니다. 다시 시도해 주세요',
  OAUTH_FETCH_USER_FAILED: () => '인증서버 오류입니다. 다시 시도해 주세요', 
  OAUTH_STATE_FAILED: () => '인증서버 오류입니다. 다시 시도해 주세요',
  OAUTH_SESSION_INVALID: () => '인증 세션에 문제가 발생했습니다. 다시 로그인 해주세요.',

  MAX_IMAGE_SIZE: () => '이미지는 20MB 이하만 업로드할 수 있습니다.',

  INVALID_PHONE_NUMBER: () => '잘못된 형식의 전화번호 입니다.',
});